import { render, staticRenderFns } from "./update-referee.vue?vue&type=template&id=1c128e6a&lang=pug"
import script from "./update-referee.vue?vue&type=script&lang=js"
export * from "./update-referee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports